declare namespace $ {

	type $mol_link__title_bog_dobro_app_vaka_item_1 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_vaka_item['title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_dobro_app_vaka_item_2 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_vaka_item['url'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_text__text_bog_dobro_app_vaka_item_3 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_vaka_item['meta'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_bog_dobro_app_vaka_item_4 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_vaka_item['salary'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_bog_dobro_app_vaka_item_5 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_vaka_item['snippet'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $bog_dobro_app_vaka_item extends $mol_card {
		title( next?: string ): string
		url( next?: string ): string
		Title( ): $mol_link
		meta( next?: string ): string
		Meta( ): $mol_text
		salary( next?: string ): string
		Salary( ): $mol_text
		snippet( next?: string ): string
		Snippet( ): $mol_text
		vacancy( ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=item.view.tree.d.ts.map